<div class="flex h-full w-full flex-col">
  <h1 class="mb-5">{{ "Клієнти" }}</h1>
  <form
    class="mb-2 flex items-center justify-start gap-8"
    [formGroup]="clientsFilterForm"
  >
    <mat-form-field class="w-1/3">
      <mat-icon matIconPrefix>search</mat-icon>
      <mat-label>{{ "Пошук за телефоном або ПІБ клієнта" }}</mat-label>
      <input
        matInput
        [type]="'text'"
        [formControl]="filtersFc.search"
      />
      @if (filtersFc.search.value) {
        <button
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    <button
      class="btn btn-filter mb-4 flex items-center"
      type="button"
      [matMenuTriggerFor]="filters"
    >
      <label class="px-1">
        {{ "Статус:&nbsp;" + ("context.filters." + filtersFc.status.value | translate) }}
      </label>
      <img
        alt="Filter"
        width="16"
        height="16"
        [ngSrc]="'/assets/icons/ic_arrow_down.svg'"
      />
    </button>
    <mat-menu
      #filters="matMenu"
      xPosition="before"
    >
      <button
        mat-menu-item
        (click)="setStatusFilterValue(clientStatusFilters.Active)"
      >
        {{ "context.filters.Active" | translate }}
      </button>
      <mat-divider></mat-divider>
      <button
        mat-menu-item
        (click)="setStatusFilterValue(clientStatusFilters.All)"
      >
        {{ "context.filters.All" | translate }}
      </button>
    </mat-menu>
  </form>

  <div
    class="relative h-0 min-h-0 flex-1 overflow-y-auto overflow-x-hidden pr-3"
    sharedInfiniteScroll
    [scrollLoading]="profilesLoading()"
    [hasNextPage]="hasNextPage()"
    (fetchNextPage)="fetchNextPage()"
  >
    <div class="h-0 min-h-full flex-1">
      <table
        mat-table
        [dataSource]="clients()"
      >
        <ng-container [matColumnDef]="headers.Name">
          <th
            *matHeaderCellDef
            mat-header-cell
          >
            {{ "ПІБ клієнта" }}
          </th>
          <td
            *matCellDef="let client"
            mat-cell
            [routerLink]="[client.id]"
          >
            <span class="cursor-pointer font-bold">
              {{ client.fullName }}
            </span>
            @if (checkFreemium(client)) {
              <span class="mx-2 rounded-full border border-success-500 bg-success-100 px-1.5 py-0.5 text-xs font-thin">
                {{ "FREE" }}
              </span>
            }
            @if (calculateAge(client.birthDate) < 18) {
              🐣
            }
          </td>
        </ng-container>
        <ng-container [matColumnDef]="headers.Phone">
          <th
            *matHeaderCellDef
            mat-header-cell
          >
            {{ "Телефон" }}
          </th>
          <td
            *matCellDef="let client"
            mat-cell
          >
            {{ client.phoneNumber ?? "Не вказано" }}
          </td>
        </ng-container>
        <ng-container [matColumnDef]="headers.BirthDate">
          <th
            mat-header-cell
            *matHeaderCellDef
          >
            {{ "Дата народження" }}
          </th>
          <td
            *matCellDef="let client"
            mat-cell
          >
            <span class="text-center">
              {{ formatDate(client.birthDate) ?? "Не вказано" }}
            </span>
          </td>
        </ng-container>
        <ng-container [matColumnDef]="headers.PolicyNumber">
          <th
            *matHeaderCellDef
            mat-header-cell
          >
            {{ "Номер поліса" }}
          </th>
          <td
            *matCellDef="let client"
            mat-cell
            class="text-xs"
          >
            {{ client.contracts.length ? findActiveContract(client.contracts).contractNumber : "Клієнт ще не має поліса &#128546; " }}
          </td>
        </ng-container>
        <ng-container [matColumnDef]="headers.PolicyTerm">
          <th
            *matHeaderCellDef
            mat-header-cell
          >
            {{ "Термін дії поліса" }}
          </th>
          <td
            *matCellDef="let client"
            mat-cell
          >
            @if (client.contracts.length) {
              <div class="flex flex-col">
                <span>{{ "з " + ((findActiveContract(client.contracts).activeFrom | date: "dd.MM.yyyy") ?? "Даних не знайдено") }}</span>
                <span>{{ "по " + ((findActiveContract(client.contracts).activeTo | date: "dd.MM.yyyy") ?? "") }}</span>
              </div>
            } @else {
              -
            }
          </td>
        </ng-container>
        <ng-container [matColumnDef]="headers.Doctor">
          <th
            *matHeaderCellDef
            mat-header-cell
          >
            {{ "ПІБ лікаря" }}
          </th>
          <td
            *matCellDef="let client"
            mat-cell
          >
            {{ client.doctorName ?? "Даних не знайдено" }}
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="columns"
          mat-header-row
          class="sticky top-0 z-10 border-b-2 border-t border-b-primary-500 border-t-neutral-200"
        ></tr>
        <tr
          *matRowDef="let _; columns: columns"
          mat-row
          class="odd:bg-primary-100"
        ></tr>
      </table>
    </div>
  </div>
  @if (clients().length && profilesLoading()) {
    <div class="my-0.5">
      <shared-spin-loading [size]="24"></shared-spin-loading>
    </div>
  }
  @if (loading()) {
    <div class="absolute inset-0 z-50 flex items-center justify-center bg-neutral-0/80">
      <shared-loader></shared-loader>
    </div>
  }
</div>
